import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import {
  handleGetSizeName,
  handleGetSize_list,
  handleQuantityChange,
  handleSizePrice,
} from "./orderModel";
import { FaExclamationCircle } from "react-icons/fa";

const SizesStep = ({
  sizeOptions,
  setSizeOptions,
  selectedType,
  selectedCloth,
  quote,
  addonOptions,
  setAddonOptions,
  selectedClothType,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sizeOptions?.length <= 0) {
      handleGetSize_list({ setLoading, setSizeOptions, quote });
    }
  }, []);

  return (
    <>
      <style>{`
        .compact-card .card-body {
          padding: 6px 10px !important;
        }
        .compact-card .fw-semibold {
          font-size: 0.85rem;
        }
        .compact-card .text-muted {
          font-size: 0.75rem;
        }
        .compact-card input[type="number"] {
          padding: 2px 6px;
          height: 30px;
          font-size: 0.85rem;
        }
      `}</style>

      {!selectedClothType && (
        <div
          className="text-danger d-flex align-items-center mt-2 p-2 rounded"
          style={{ backgroundColor: "#ffe6e6", fontSize: "0.9rem" }}
        >
          <FaExclamationCircle className="me-2" />
          Please select a cloth type to continue.
        </div>
      )}

      <div>
        {loading ? (
          <div className="text-center my-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          sizeOptions.map((item) => (
            <Card key={item.id} className="mb-2 compact-card" style={{ cursor: "default" }}>
              <Card.Body>
                <Row className="align-items-center">
                  <Col xs={3} sm={3}>
                    <div className="fw-semibold">
                      {handleGetSizeName(item, selectedType,0)}
                    </div>                   
                    <div className="text-muted fw-bold">
                      ₹{selectedClothType?.sub_price || 0}
                    </div>
                  </Col>
                  <Col xs={3} sm={3}>
                    <div className="fw-semibold">
                      {handleGetSizeName(item, selectedType,1)}
                    </div>                   
                  </Col>
                  <Col xs={6} sm={6} className="text-end">
                    <Form.Control
                      type="number"
                      min="0"
                      placeholder="0"
                      value={item?.qty <=0 ? "" : item?.qty}
                      onChange={(e) =>
                        handleQuantityChange(
                          item.id,
                          parseInt(e.target.value) || 0,
                          sizeOptions,
                          setSizeOptions,
                          selectedClothType?.sub_price || 0,
                          addonOptions,
                          setAddonOptions
                        )
                      }
                      disabled={selectedClothType == "" || selectedClothType == undefined ? true : false}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))
        )}
      </div>
    </>
  );
};

export default SizesStep;
